module.exports = __webpack_public_path__ + "img/borderRing2_UPWhite.110ef708.svg";